import { useLocation, useNavigate } from "react-router";
import Layout from "../../components/Layout";
import { usePostDatevAuth } from "../../client/hooks";
import { useEffect, useState } from "react";
import { ApiError, DatevAuth } from "../../api";
import ErrorAlert from "../../components/ErrorAlert";

export default function Datev() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("codeExt");
  const state = queryParams.get("stateExt");
  let stateStorage = localStorage.getItem("DATEV_STATE");
  const postDatevAuth = usePostDatevAuth();
  const navigate = useNavigate();

  const [error, setError] = useState<ApiError | null>(null);

  useEffect(() => {
    const fetchAccessToken = async () => {
      if (code) {
        try {
          if (stateStorage !== state) {
            console.error("Invalid state");
            return;
          }
          let response: DatevAuth = await postDatevAuth({ code: code });
          if (response.accessToken !== undefined) {
            navigate("/externesysteme");
          }
        } catch (error: ApiError | any) {
          error.body.message = "Datev auth failed: " + error.body.message;
          setError(error);
          console.error("Error fetching access token:", error.body.message);
        }
      }
    };

    fetchAccessToken();
  }, [code, state]);

  if (stateStorage !== state) {
    return (
      <Layout title="Datev" showTitleInNav={false}>
        <div>State not found</div>
      </Layout>
    );
  }
  return (
    <Layout title="Datev" showTitleInNav={false}>
      {error && <ErrorAlert error={error.body} />}
    </Layout>
  );
}
